var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulkActionAssignee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87184 19.5447C4.64406 19.5447 3.90213 18.6623 3.84961 17.4331C3.84961 14.9312 6.29424 14.0682 9.97759 14.0391C13.6675 14.0779 16.1187 14.9409 16.1056 17.4331C16.0465 18.6623 15.3089 19.5447 14.0833 19.5447H5.87184Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6429 18.8155H20.2088C21.2028 18.8155 21.801 18.0998 21.8489 17.1029C21.8582 15.3462 20.3577 14.5876 18 14.3984",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95838 10.9011C11.7379 10.9011 13.1804 9.45857 13.1804 7.67908C13.1804 5.89959 11.7379 4.45703 9.95838 4.45703C8.17889 4.45703 6.73633 5.89959 6.73633 7.67908C6.73633 9.45857 8.17889 10.9011 9.95838 10.9011Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9854 10.7598C19.1444 10.7598 20.084 9.82018 20.084 8.66113C20.084 7.50209 19.1444 6.5625 17.9854 6.5625C16.8263 6.5625 15.8867 7.50209 15.8867 8.66113C15.8867 9.82018 16.8263 10.7598 17.9854 10.7598Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkActionAssignee);
export default __webpack_public_path__ + "static/media/bulk-action-assignee.7c3510b61775eff3a71acfbda6731ca2.svg";
export { ForwardRef as ReactComponent };